<template>
  <div
    v-for="(section, sectionIndex) in sections"
    v-show="isSectionVisible(section)"
    :id="section.slug"
    :key="section.slug || sectionIndex"
    :class="section.classes"
    class="section"
  >
    <div
      v-for="(content, contentIndex) in section.content"
      :key="contentIndex"
      class="block"
    >
      <component
        :is="component(content)"
        v-bind="content.props"
        :id="content.slug"
      >
        <template
          v-for="(slot, key) in slotContent(content)"
          #[key]="slotProps"
          :key="key"
        >
          <component
            :is="component(element)"
            v-for="(element, elementIndex) in slot"
            :key="elementIndex"
            :class="element.class"
            v-bind="{ ...element.props, ...slotProps }"
            @backToContents="
              slotProps.onBackToContents && slotProps.onBackToContents()
            "
          >
            {{ element.text }}
            <template v-if="element.children">
              <component
                :is="component(child)"
                v-for="(child, childIndex) in element.children"
                :key="childIndex"
                :class="child.class"
                v-bind="child.props || {}"
              >
                {{ child.text }}
                <template v-if="child.children">
                  <component
                    :is="component(grandChild)"
                    v-for="(grandChild, grandChildIndex) in child.children"
                    :key="grandChildIndex"
                    :class="grandChild.class"
                    v-bind="grandChild.props || {}"
                  >
                    {{ grandChild.text }}
                  </component>
                </template>
              </component>
            </template>
          </component>
        </template>
      </component>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";

export default {
  name: "HeadlessLayout",
  props: {
    sections: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    component(content) {
      if (content.tag) {
        return content.tag;
      }

      return defineAsyncComponent(() =>
        import(
          /* webpackChunkName: "[request]" */ `@/components/${content.component}.vue`
        )
      );
    },
    slotContent(item) {
      return item.slot;
    },
    isSectionVisible(section) {
      if (!section?.slug) {
        return true;
      }

      const activeSlug =
        this.$store.state.sustainability?.selectedSection || "introduction";
      return section.slug === activeSlug;
    },
  },
};
</script>

<style lang="scss" scoped>
.single {
  margin: 0 0 2px 0;
}

.grid {
  display: grid;
  gap: 2px;

  @include respond-above(md) {
    &--1col {
      grid-template-columns: 1fr;
    }

    &--2col {
      grid-template-columns: 1fr 1fr;
    }
  }
}
</style>
